import type { BookingTranslations } from "../../../pt-BR/event/booking";

export const BOOKING_ES_ES: BookingTranslations = {
	reserve: {
		label: "Paquetes",
		search: "Buscar paquetes",
		create: "Crear paquete",
		empty: {
			title: "Sin paquetes para este evento",
			subtitle:
				"Cree su primer paquete haciendo clic en el botón ¨Crear paquete¨ en la parte superior de esta página",
		},
		reserveCard: {
			guests: "{{count}} invitados",
			promotions: "{{count}} promociones",
			none: "Ninguna promoción seleccionada",
			people: "{{count}} personas confirmadas",
		},
		reserveDetail: {
			title: "Paquete de",
			confirmed: "{{count}} confirmados",
			of: "de",
			guestsCount: "{{count}} invitados",
			delete: "¿Está seguro de que desea eliminar este producto?",
			promotions: "Promociones del paquete",
			none: "Ninguna promoción seleccionada",
			guests: "Invitados",
			invoices: "Facturas generadas",
			invoiceIssuingLabel: "Emitiendo factura...",
			invoiceCanceledLabel: "Factura cancelada",
			invoiceErrorLabel: "Error al emitir factura",
			invoiceModeLabel: "Modo de emision:",
			value: "Valor del paquete",
			issueInvoice: "Emitir factura",
			copyModal: {
				defaultReserveName: "Copia de {{name}}",
				title: "Crear copia del paquete",
				copy: "Copiar",
				text: "¿Desea crear una copia de reserva?",
				placeholder: "Nombre de la copia del paquete",
				errors: {
					inputs: "Los campos no se rellenaron correctamente.",
					name: "El nombre del paquete es igual al nombre original.",
					length:
						"El nombre del paquete no ha alcanzado la cantidad mínima de caracteres.",
				},
			},
			modal: {
				title: "Emitir factura para {{name}}",
				issueInvoice: "Emitir factura",
				fiscalProfile: "Perfil Fiscal",
				cpf: "NIF",
				cnpj: "CIF",
				none: "Ninguno",
				paymentMethod: "Método de pago",
				fiscalGroup: "Grupo Fiscal",
				ncm: "NCM",
				cest: "CEST",
				value: "Valor",
				remove: "Eliminar",
				add: "Agregar grupo fiscal",
				tip: "Propina",
				removeTip: "Eliminar propina",
				invoiceValue: "Valor de la factura",
				invoiceAlert: "Las facturas con valor superior a €10.000 serán divididas.",
				alreadyIssuedInvoiceAlert: "Este paquete ya tiene facturas emitidas.",
				alreadyIssuedInvoiceConfirm:
					"¿Estás seguro de que deseas emitir? Este paquete ya tiene facturas emitidas.",
				packageValue: "Valor del paquete",
				discount: "Descuentos",
				total: "Total",
				chooseOptions: "Elija una de las opciones",
				addDiscount: "Agregar descuentos a la factura",
				completeValue: "Completar el valor del paquete",
				recipientRazaoSocial: "Razón Social",
				recipientInscricaoEstadual: "Registro Fiscal",
				recipientIndicador: "Indicador de Registro Fiscal",
				recipientAddress: "Dirección",
				logradouro: "Calle",
				numero: "Número",
				complemento: "Complemento",
				bairro: "Barrio",
				cep: "Código Postal",
				municipio: "Municipio",
				uf: "Comunidad Autónoma",
				optionalTip: {
					title: "Propina (opcional)",
					add: "Agregar propina",
				},
				inputMultiplePaymentsManual: {
					label: "Método de pago",
					placeholder: "Seleccionar",
					value: "Valor",
					add: "Agregar pago",
				},
				errors: {
					value: "Incluya algún producto con valor para utilizar esta funcionalidad",
					inputs: "Los campos no se rellenaron correctamente",
				},
				invoiceProcessing: "La factura está siendo procesada...",
				invoiceIssuingSoon: "La factura será emitida en unos instantes",
				invoiceIssuedSuccess: "Factura emitida con éxito",
			},
			tableMultiplePayment: {
				columns: {
					paymentMethod: "Método de pago",
					value: "Valor",
				},
				total: "Total agregado",
			},
			peopleDidntArrive: {
				title: "Desconocido",
				subtitle: "Sin información",
			},
			peopleArrived: {
				title: "En el evento",
				subtitle: "Ya se fue",
			},
		},
		reserveModal: {
			inactive: " (Promoción inactiva)",
			edit: "Editar paquete",
			create: "Crear",
			newTemplate:
				"¡Atención! El modelo creado podrá ser utilizado por todos los eventos de este lugar.",
			template:
				"El paquete puede ser personalizado, pero creará una asociación al modelo para ser utilizado en informes y métricas.",
			models: "Modelos",
			clientInfo: "Información del cliente",
			name: "Nombre",
			estimatedPeopleCount: "Número de invitados",
			value: "Valor del paquete",
			expiresAt: "Expira en",
			promotion: "Promoción",
			promotionLabel: "Promoción {{number}}",
			updateModal: {
				promotionName: "Nombre de la promoción",
				description: "Descripción",
				productName: "Nombre del producto",
				percentage: "Porcentaje",
			},
			modalTitle: {
				edit: "Editar {{name}}",
				newTemplate: "Crear modelo",
				template: "Crear a partir de modelo",
				create: "Crear paquete",
			},
			errors: {
				selectedTemplate: "El modelo no pudo ser encontrado",
				promotion: "Ninguna promoción seleccionada",
				inputs: "Complete todos los campos obligatorios para la categoría seleccionada.",
			},
		},
		reserveOptions: {
			create: {
				name: "Crear paquete personalizado",
				label:
					"Defina cómo será el paquete ofrecido e incluya una promoción si lo desea.",
			},
			createWithTemplate: {
				name: "Crear a partir de modelo",
				label:
					"Cree un paquete para sus clientes basado en los modelos creados anteriormente.",
			},
			createTemplate: {
				name: "Crear nuevo modelo",
				label:
					"Cree un modelo personalizado de paquete para utilizar en el futuro en sus eventos.",
			},
			canBeUsedIn: "Podrá ser utilizado en",
			allEvents: "todos los eventos",
			fromThisPlace: "de este lugar",
			managePackages: "Gestionar paquetes",
		},
		reserveTemplate: {
			loading: "Cargando ...",
			empty: "El lugar no tiene ningún modelo registrado.",
			remove: "Eliminar",
			value: "Valor del paquete",
			guests: "Invitados",
			promotions: "Promociones",
			modalConfirm: {
				title: "¿Está seguro de que desea eliminar el modelo?",
				content: "Ya no podrá ser utilizado en ningún evento de este lugar.",
			},
		},
	},
	reserveReport: {
		label: "Informe de paquetes",
		subtitle: {
			none: "Ningún paquete activo durante el evento",
			one: "un paquete activo durante el evento",
			default: "{{count}} paquetes activos durante el evento",
		},
	},
};
